import ReviewDrawerController from './review_drawer_controller'

export default class extends ReviewDrawerController {
  static drawerFrameId = 'review_drawer'

  static targets = [
    ...ReviewDrawerController.targets,
    'heading',
  ]

  connect() {
    super.connect()

    this.streamRenderHandler = (event) => {
      const stream = event.target
      if (stream.target !== this.constructor.drawerFrameId) return

      const { detail } = event
      const originalRender = detail.render

      detail.render = (currentElement) => {
        originalRender(currentElement)

        requestAnimationFrame(() => {
          const frame = document.getElementById(
            this.constructor.drawerFrameId,
          )
          this.focusDrawerContent()
          this.syncUrlToLoadedDrawerItem(frame)

          const container = frame?.querySelector('[data-import-item-id]')

          if (container?.dataset.importItemId) {
            this.announce('Loaded the next document for review')
          } else {
            this.announce('There are no more items to review')
          }
        })
      }
    }

    document.addEventListener(
      'turbo:before-stream-render',
      this.streamRenderHandler,
    )

    this.refreshFromUrl()

    if (this.openValue) {
      requestAnimationFrame(() => {
        this.focusDrawerContent()
        this.announce('Review drawer opened')
      })
    }
  }

  disconnect() {
    document.removeEventListener(
      'turbo:before-stream-render',
      this.streamRenderHandler,
    )
    super.disconnect()
  }

  close() {
    if (!this.openValue && !this.closing) {
      this.removeImportItemIdFromUrl()
      return
    }

    super.close()
  }

  refreshFromUrl() {
    if (this.closing) return

    const url = new URL(window.location.href)
    const shouldBeOpen = url.searchParams.has('import_item_id')

    if (shouldBeOpen) {
      this.open()
    } else {
      this.close()
    }
  }

  afterClose() {
    this.removeImportItemIdFromUrl()
  }

  afterFrameLoad() {
    this.focusDrawerContent()
  }

  announce(message) {
    if (!this.hasLiveRegionTarget) return

    this.liveRegionTarget.textContent = ''

    window.requestAnimationFrame(() => {
      this.liveRegionTarget.textContent = message
    })
  }

  focusDrawerContent() {
    if (this.hasPrimaryFieldTarget && !this.primaryFieldTarget.disabled) {
      this.primaryFieldTarget.focus()
      return
    }

    if (this.hasHeadingTarget) {
      this.headingTarget.focus()
    }
  }

  removeImportItemIdFromUrl() {
    const currentWindow = this.element.ownerDocument.defaultView
    const url = new URL(currentWindow.location.href)
    url.searchParams.delete('import_item_id')
    currentWindow.history.replaceState({}, '', url.toString())
  }

  syncUrlToLoadedDrawerItem(frame) {
    if (!frame) return

    const currentWindow = this.element.ownerDocument.defaultView
    const container = frame.querySelector('[data-import-item-id]')
    const importItemId = container?.dataset.importItemId
    const url = new URL(currentWindow.location.href)

    if (importItemId) {
      url.searchParams.set('import_item_id', importItemId)
    } else {
      url.searchParams.delete('import_item_id')
    }

    currentWindow.history.replaceState({}, '', url.toString())
  }
}
